<template>
  <div class="text-standard">
    <div class="min-660 spring bg-cover bg-center" />
    <div class="container mx-auto my-16 px-4 lg:px-0">
      <h2 class="laptop:text-55xl md:text-5xl">Spring Chair</h2>
    </div>
    <div class="container mx-auto w-full relative min-660" style="padding-top:50%">
      <iframe
        allow="xr-spatial-tracking *;fullscreen *; web-share *" allowfullscreen allowtransparency="true"
        class="absolute top-0 bottom-0 left-0 right-0 min-660"
        :src="'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/55c33d9f-6bee-507e-bcbc-bb03754a030e/default/f18af829-384e-52cc-9942-660c61ded0fd/index.html?language=' + $i18n.locale"
        style="width:100%; height:100%;"
      />
    </div>
    <div class="container mx-auto mt-32 laptop:mt-150px">
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-12 md:mx-32 lg:mx-0">
        <div class="flex flex-col text-center px-12">
          <img loading="lazy" alt="Minimal" src="~/assets/img/examples/ico-chair.svg">
          <h3 class="my-4 font-bold text-2xl">Minimal</h3>
          <p>The use of geometric shapes and simple <br>materials makes this chair suitable for any environment.</p>
        </div>
        <div class="flex flex-col text-center px-12">
          <img loading="lazy" alt="Modern" src="~/assets/img/examples/ico-circle.svg">
          <h3 class="my-4 font-bold text-2xl">Modern</h3>
          <p>We welcome with enthusiasm when we are offered to study a new object for a specific space.</p>
        </div>
        <div class="flex flex-col text-center px-12">
          <img loading="lazy" alt="Sustainable" src="~/assets/img/examples/ico-leaf.svg">
          <h3 class="my-4 font-bold text-2xl">Sustainable</h3>
          <p>One of the reasons why we exist.<br> Sustainability guides our daily choices and management approach.</p>
        </div>
      </div>
    </div>
    <div class="container mx-auto mt-32 laptop:mt-150px flex flex-row flex-wrap">
      <div class="w-full">
        <img loading="lazy" alt="Spring chair" src="~/assets/img/examples/spring-block.webp">
      </div>
      <div class="w-full flex mt-32">
        <div class="laptop:w-6/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-full">
          <h3 class="text-standard laptop:text-3xl font-bold mb-4 md:w-full laptop:w-full md:text-3xl md:leading-normal laptop:leading-tight">
            From sketch to final result
          </h3>
        </div>
      </div>
      <div class="w-full flex flex-wrap md:mx-3 laptop:mx-0">
        <div class="laptop:w-6/12 px-5 lg:pr-8 laptop:px-24 lg:w-1/2 w-full">
          <p>We care about your spaces since we start thinking about them.
            Reverse is an interior design studio and a handcrafted studio-lab for furniture, fittings, installations and
            design products in limited series. Each Reverse product is environmental friendly, studied in detail,
            tailored made, for you. www.reverselab.it</p>
        </div>
        <div class="laptop:w-6/12 px-5 lg:pl-8 laptop:px-24 lg:w-1/2 w-full">
          <p>This is an example of integration of 3D contents inside a website. It is intended to suggest ideas of
            applications on e-commerce and info-commerce of the outputs of My AR Studio.
            For further information see: myarstudio.cloud</p>
        </div>
      </div>

      <div class="w-full bg-springgray mt-32 laptop:mt-100px">
        <img loading="lazy" alt="Spring chair" class="mx-auto my-24" src="~/assets/img/examples/spring-schema-1.webp">
      </div>

      <div class="w-full mt-32 laptop:mt-100px">
        <img loading="lazy" alt="Spring chair" class="mx-auto my-24" src="~/assets/img/examples/spring-schema-2.webp">
      </div>

    </div>
    <div class="laptop:mx-24">
      <div class="container mx-auto mt-32 laptop:mt-0" style="max-width: 1280px;">
        <div style="position: relative; width: 100%; padding-top: 56.22%;">
          <div class="w-full h-full absolute top-0">
            <iframe v-if="youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/ZISQ1LHhsAU?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale == 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/ZISQ1LHhsAU?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube.com/embed/zoYL91VlvGo?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
            <iframe v-if="!youtubeEnabled && $i18n.locale != 'it'" width="100%" height="100%" src="https://www.youtube-nocookie.com/embed/zoYL91VlvGo?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
          </div>
        </div>
      </div>
    </div>
    <TryIt />
    <div class="hidden md:block">
      <img loading="lazy" alt="Spring schema" class="mx-auto" src="~/assets/img/examples/spring-schema.webp">
    </div>
  </div>
</template>

<script setup lang="ts">
import { useIubenda } from 'mars-iubenda-vite';

const {youtubeEnabled} = useIubenda()
</script>

<style scoped>
.spring {
  background-image: url("~/assets/img/examples/spring-hero.webp");
}
</style>
